import { FastlyImage } from '@components/common/image'
import Modal from '@components/common/modal'
import { useState } from 'react'
import YouTube from 'react-youtube'

const VideoFold = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="bg-orange-200 bg-opacity-75 pt-20 pb-20 px-3 text-grey">
      <div className="max-w-5xl mx-auto items-center flex flex-col">
        <h2 className="mb-10 text-2xl leading-tight text-center lg:text-4xl font-600 max-w-full w-2xl">
          Watch now - What it is like to learn coding at Codingal!
        </h2>
        <div
          className="rounded-lg lg:w-4/5"
          onClick={() => {
            setIsOpen(true)
          }}
        >
          <FastlyImage
            src="/images/school-partnership/video-placeholder.png"
            webpSrc="/images/school-partnership/video-placeholder.webp"
            width="1032px"
            height="614px"
            className="hover:shadow-xl transition duration-500 cursor-pointer"
          />
        </div>
        <Modal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isCrossIconShown={true}
          width="w-full max-w-full mt-12 sm:mt-5"
          className="bg-black pl-0 pr-0"
        >
          <YouTube
            videoId="s9iKuZJSxc0"
            className="-my-5 sm:-my-10 rounded-lg w-full sm:h-screen"
            opts={{
              playerVars: {
                autoplay: 1,
              },
            }}
          />
        </Modal>
      </div>
    </div>
  )
}

export default VideoFold
